import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  get_proforma_doc,
  UpdateProfomaDoc,
  // UploadProfomaDoc,
  // upload_proforma_doc,
} from "../../actions/orders/Action";
import close from "../../assets/cancel_w.svg";
import { amountFormat } from "../../config/helper";

const ProfomaDoc = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const profoma_doc = useSelector((state) => state.orders.profoma_doc);
  const signature_url = profoma_doc?.data?.signature_url;
  const update_profoma_doc = useSelector(
    (state) => state.orders.update_profoma_doc
  );
  // const upload_perfoma_doc = useSelector(
  //   (state) => state.orders.upload_perfoma_doc
  // );
  const history = useHistory();

  useEffect(() => {
    dispatch(
      get_proforma_doc({
        email: localStorage.getItem("email"),
        sales_order: location.state?.sales_order,
      })
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (update_profoma_doc.success) {
      toast.success(update_profoma_doc?.data?.message || "Updated Status");
      dispatch({
        type: UpdateProfomaDoc.RESET,
      });
      history.goBack();
    }

    if (update_profoma_doc?.data?.status === false) {
      toast.error(update_profoma_doc?.data?.message);
      dispatch({
        type: UpdateProfomaDoc.RESET,
      });
    }
    // eslint-disable-next-line
  }, [update_profoma_doc]);

  // useEffect(() => {
  //   if (upload_perfoma_doc?.success) {
  //     toast.success("Signed Proforma Invoice uploaded successfully.");
  //     dispatch({
  //       type: UploadProfomaDoc.RESET,
  //     });
  //     history.goBack()
  //   }

  //   if (upload_perfoma_doc?.data?.status === false) {
  //     toast.error(upload_perfoma_doc?.data?.message);
  //     dispatch({
  //       type: UploadProfomaDoc.RESET,
  //     });
  //   }
  //   // eslint-disable-next-line
  // }, [upload_perfoma_doc]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== "https://app.pandadoc.com") return;
      const type = event.data && event.data.type;  
      switch (type) {
        case 'session_view.document.loaded':
          break;
        case 'session_view.document.completed':

          // Dispatch update if needed
          dispatch({
            type: UpdateProfomaDoc.RESET,
          });  
          toast.success("Redirecting in 5 seconds...");
          // Wait 7 seconds before redirecting
          setTimeout(() => {
            // Redirect to portal or desired page
            history.push("/order-detail");
          }, 7000); // 7 seconds
          break;
        case 'session_view.document.exception':
          break;
        default:
          break;
      }
    };
      window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="profoma-doc">
      <div className="profoma-header">
        <div>
          <span>Order ID - {location.state?.order_no}</span>
          <span>
            {location.state?.time} | ${amountFormat(location.state?.amount)}
          </span>
        </div>
        <div className="flex-center">
          {/* <input id="file" className="d-none" type={"file"} onChange={(e) => {
            let formData = new FormData()
            formData.append("so_number", location.state?.sales_order)
            formData.append("files", e.target.files[0])
            dispatch(upload_proforma_doc(formData))
          }} />
          <button
            className="approve-btn mr2"
            onClick={() => {
              document.getElementById("file").value = ""
              document.getElementById("file").click()
            }}
            disabled={upload_perfoma_doc?.loading}
          >
            {upload_perfoma_doc?.loading ? "Uploading" : "Upload"} Signed Doc
          </button> */}
          <img
            src={close}
            alt={"close"}
            width={20}
            onClick={() => history.goBack()}
          />
        </div>
      </div>
      <div>
      {signature_url ? (
        <iframe
          src={signature_url}
          title="Proforma PDF"
          width="100%"
          height="600px"
        />
      ) : (
        <p>Loading document...</p>
      )}
      </div>
    </div>
  );
};

export default ProfomaDoc;
